var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoPrefactura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 0C4.5 0 1.65333 2.07333 0.5 5C1.65333 7.92667 4.5 10 7.83333 10C11.1667 10 14.0133 7.92667 15.1667 5C14.0133 2.07333 11.1667 0 7.83333 0ZM7.83333 8.33333C5.99333 8.33333 4.5 6.84 4.5 5C4.5 3.16 5.99333 1.66667 7.83333 1.66667C9.67333 1.66667 11.1667 3.16 11.1667 5C11.1667 6.84 9.67333 8.33333 7.83333 8.33333ZM5.83333 5C5.83333 3.89333 6.72667 3 7.83333 3C8.94 3 9.83333 3.89333 9.83333 5C9.83333 6.10667 8.94 7 7.83333 7C6.72667 7 5.83333 6.10667 5.83333 5Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPrefactura);
export default __webpack_public_path__ + "static/media/icono_prefactura.cbe8e16dca506a4926af4e607cecd688.svg";
export { ForwardRef as ReactComponent };